const NoData = () => {
  return (
    <div className="flex flex-col h-[70vh] w-full justify-center items-center">
      <img
        src="/assets/info.svg"
        alt="info icon"
        className="mb-[2vw] w-[10vw]"
      />
      <p className="text-center text-[3.5vw] font-bold m-0 text-[#989898]">
        비교할 데이터가
      </p>
      <p className="text-center text-[3.5vw] font-bold m-0 text-[#989898]">
        존재하지 않습니다.
      </p>
    </div>
  );
};
export default NoData;
